<template>
  <div class="swiper2 posRe">
    <div class="swiper-container container-swiper2 container-swiper-te" id="swiper2">
      <div class="swiper-wrapper">
        <template v-for="(list, index) in lists">
          <div :class="['swiper-slide',(hoveIndex==index?'hover':'')]"  :key = "'swiper1'+index"  @click="swiperSlide(index)" :id-name="'city-swiper2-'+index">
            <swiper-list :item="list" loop="true" :class-name="'city-swiper2-'+index" :lazy="lazy" :hover="hoveIndex" :index="index" :state="state"></swiper-list>
          </div>
        </template>
        <!--<template v-if="total<5">
          <template v-for="(list, index) in (5-total)">
            <div :class="['swiper-slide',(hoveIndex==(total+index)?'hover':'')]"  :key = "'swiper1'+(total+index)"  @click="swiperSlide(total+index)" :id-name="'city-swiper2-'+(total+index)">
              <swiper-list :item="defaultData" loop="true" :class-name="'city-swiper2-'+(total+index)" :lazy="lazy" :hover="hoveIndex" :index="index+total" :state="state"></swiper-list>
            </div>
          </template>
        </template>-->
      </div>
    </div>
    <template v-if="lists.length>4">
      <div class="next-prev next-btn"><span class="icon-img"></span></div>
      <div class="next-prev prev-btn"><span class="icon-img"></span></div>
    </template>
  </div>
</template>

<script>
import swiperList from '@/components/swiperList1'
//import Bus from '@/common/bus.js'
export default {
  name: 'swiper2',
  props: ['state', 'client'],//cityCard
  data () {
    return {
      lists: [],
      seating: '',
      lazy: {
        bool: true,
        elementClass: 'swiper2-img',
        loading: './static/images/icon/loading3.png'
      },
      hoveIndex: -1,
      containerSwiper2: '',
      marginTop: '-20px',
      total: 0,
      params: {
        page: 1,
        cityId: 0,
        limit: 100
      },
      c: 0,
      cityData:{

      },
      defaultData:[
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
        {address: "", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
      ],
      cityCard:{}
    }
  },
  components: {
    swiperList: swiperList
  },
  created () {
    let that = this;
    if (that.state === 2) {
      let c = JSON.parse(that.publicJs.decode(that.$route.query));
      that.params.cityId = c.cityId;
      that.params.typeId = c.typeId
    }
    /*Bus.$on("GetSiteInfoByCityData",function (val) {
      that.cityCard=val;
    })*/

  },
  mounted () {
  },
  methods: {
    httpData: function () {
      let _that = this;
      _that.httpAjax.getAjax('PanoWebService.asmx/GetRecommendByCity', _that.params).then(function (data) {
        if (data.code === 1) {
          _that.total = data.total;
          /*data.data=[
           {address: "qqq", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
            {address: "wwwww", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
            {address: "xxxxx", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
            {address: "ccccc", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
            {address: "ccccc", good: "", id:0, imgSrc: "", name: "", panoUrl: "", phone: "", share: 0, x: "", y: "", defaultBool:true},
          ]*/
          let len=data.data&&data.data.length?data.data.length:0;
          if(len<5){
            let startIndex=Math.floor((5-len)/2);
            _that.lists=_that.defaultData.slice(0,startIndex).concat(data.data,_that.defaultData.slice(startIndex,5-len))
          }else {
            _that.lists=data.data
          }
          _that.httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: _that.params.cityId}).then(function (res) {
            if (res.code === 1) {
              let data = res.data && res.data.length ? JSON.parse(JSON.stringify(res.data[0])) : {};
              let cityCard={};
              if(data&&JSON.stringify(data)!='{}'){
                cityCard.name=data.charmPanoUrl?data.charmName:'';
                cityCard.imgSrc=data.charmPanoImg;
                cityCard.panoUrl=data.charmPanoUrl;
                cityCard.cityBool=true;
                cityCard.defaultBool=data.charmPanoUrl?false:true;
                _that.lists.splice(2,0,cityCard);
                _that.$nextTick(function () {
                  _that.swiperFun()
                })
              }else {
                _that.$nextTick(function () {
                  _that.swiperFun()
                })
              }

            }
          }, function (err) {
            console.log(err)
            _that.$nextTick(function () {
              _that.swiperFun()
            })
          })

        }
      }, function (err) {
        console.log(err)
      })
    },
    swiperFun: function () {
      let _that = this
      let showSlideNum = 2
     /* switch (_that.client) {
        case 1:
          showSlideNum = 3
          break;
        default :
          showSlideNum = 2
      }*/
      // eslint-disable-next-line
      let lenBool = _that.total > 4 ? true : false
      // eslint-disable-next-line
      _that.containerSwiper2 = new Swiper('.container-swiper2', {
//        loop: lenBool,
        loop: true,
        preventLinksPropagation: false,
        uniqueNavElements: true,
        speed: 1500,
        /*
       autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          waitForTransition: true
        },
        */
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: (5 > 4 ? 2 : 0),
        spaceBetween: 0,
        watchOverflow: true,
        watchSlidesProgress: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 4,
          elementClass: 'swiper2-img'
        },
        navigation: {
          nextEl: '.next-btn',
          prevEl: '.prev-btn'
        },
        observer: true,
        observeSlideChildren: true,
        observeParents: true,
        on: {
          progress: function (progress) {
            let slidesAll = this.slides
            for (let i = 0; i < slidesAll.length; i++) {
              let slide = slidesAll.eq(i)
              let slideProgress = slidesAll[i].progress
              let modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              }
              let translate = slideProgress * modify * 150 + 'px'
              let scale = 1 - Math.abs(slideProgress) / 4
              let zIndex = 9999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform('translateX(' + translate + ') scale(' + scale + ')')
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > showSlideNum) {
                slide.css('opacity', 0)
                slide.addClass('slide-opacity')
              } else {
                slide.removeClass('slide-opacity')
              }
            }
          },
          init: function () {
          },
          slideChangeTransitionStart: function () {
            let i = this.activeIndex
            let p = _that.params.page
            let l = _that.params.limit
           /* if (p && l && (p * l < _that.total) && (p * l <= i + 4)) {
              _that.params.page++
            }*/
            let slide = $('.swiper2 .swiper-slide').eq(i)
            let slideSiblings = slide.siblings().find('.only-list-code>div>div')
            slideSiblings.attr('id', '')
            let idSlide = slide.attr('id-name')
            slide.find('.only-list-code>div>div').attr('id', idSlide)
          },
          setTransition: function (transition) {
            let slidesAll = this.slides
            for (let i = 0; i < slidesAll.length; i++) {
              let slide = slidesAll.eq(i)
              slide.transition(transition)
            }
          },
          slideChangeTransitionEnd: function (swiper) {
            if (this.realIndex === 0) {
              _that.containerSwiper2.slideTo(this.activeIndex)
            }
          }
        }
      })
      $(document).find('.swiper2 .icon-qr').mouseenter(function () {
        var idName = $(this).parents('.swiper-slide').attr('id-name')
        _that.publicJs.qrCode(idName, true)
      })
    },
    swiperSlide: function (n) {
      this.containerSwiper2.slideToLoop(n)
    }
  },
  watch: {
    params: {
      handler: function (a, b) {
        this.httpData()
      },
      deep: true
    },
    'cityCard': {
      handler: function (a, b) {
        if(JSON.stringify(a)!=JSON.stringify(b)){
          console.log('555555')
//          this.httpData()
        }
      },
      deep: true
    },
    '$route': {
      handler: function (a, b) {
        let that = this
        if (a !== b) {
          that.lists = []
          let c = JSON.parse(that.publicJs.decode(that.$route.query))
          that.params.cityId = c.cityId
          that.params.typeId = c.typeId
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper2{
    padding:0 80px 13px;
    min-height: 96px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .swiper-container{
    padding: 0 30px;
    overflow: hidden;
  }
  .swiper-wrapper{
    align-items: center;
  }
  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    /*opacity: 0;*/
    width: 524px;
    height: 320px;
    transform-origin: center;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
  }
  .swiper-slide.slide-opacity{
  }
  .swiper-slide>div{
    border-radius: 10px;
  }
  .swiper-slide-active>div{
  }
  .next-prev{
    position: absolute;
    top:50%;
    margin-top: -20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    z-index: 5;
    overflow: hidden;
    -webkit-box-shadow: 0 1px 1px 0 #0e8bff;
    -moz-box-shadow: 0 1px 1px 0 #0e8bff;
    box-shadow: 0 1px 1px 0 #0e8bff;
    background-color: white;
  }
  .next-prev:hover{
    -webkit-animation: nextPrevAnimate 068s 2;
    -o-animation: nextPrevAnimate 0.6s 2;
    animation: nextPrevAnimate 0.6s 2;
  }
  .next-prev:hover .icon-img{
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
  }
  .prev-btn{
    left: 110px;
  }
  .next-btn{
    right: 110px;
  }
  .icon-img{
    position: absolute;
    top:0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .prev-btn .icon-img{
    left: 0;
    background-position: -195px -404px;
  }
  .next-btn .icon-img{
    right: 0;
    background-position: -304px -404px;
  }
  .prev-btn:hover .icon-img{
    -webkit-animation: btnLeftAnimate 1s;
    -o-animation: btnLeftAnimate 1s;
    animation: btnLeftAnimate 1s;
  }
  .next-btn:hover .icon-img{
    -webkit-animation: btnRightAnimate 1s;
    -o-animation: btnRightAnimate 1s;
    animation: btnRightAnimate 1s;
  }

  @keyframes btnLeftAnimate {
    0%{
      left: 0;
    }
    60%{
      left: -25px;
    }
    80%{
      left: 25px;
      opacity: 0;
    }
    100%{
      opacity: 1;
      left: 0;
    }
  }
  @keyframes btnRightAnimate {
    0%{
      right: 0;
    }
    60%{
      right: -25px;
    }
    80%{
      right: 25px;
      opacity: 0;
    }
    100%{
      opacity: 1;
      right: 0;
    }
  }
  @keyframes nextPrevAnimate {
    0%{
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
    100%{
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -ms-transform: scale(1.1);
      -o-transform: scale(1.1);
      transform: scale(1.1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper2.vue